export default "__VITE_ASSET__TSn4joM1__"